import environment from "environment";
import { BaseModel } from "sjs-base-model";

export default class SimulazioneStepOneFormModel extends BaseModel {
    public readonly cliente: string = "";
    public readonly atc: string = "";
    public readonly idAdministration?: number = undefined;
    public readonly amministrazioneNonCensita: boolean = true;
    public readonly amministrazioneCensita: boolean = false;
    public readonly eccezione: boolean = false;
    public readonly dataNascita: string = "";
    public readonly nettoMensile: string = "";
    public readonly pensioneNettaMensile: string = "";
    public readonly dataAssunzione: string = "";
    public readonly dataPensionamento: string = "";
    public readonly boxOneRata: string = "";
    public readonly boxOneDurata?: number = undefined;
    public readonly boxTwoImporto: string = "";
    public readonly boxTwoRata: string = "";
    public readonly boxThreeImporto: string = "";
    public readonly boxThreeDurata?: number = undefined;
    public readonly canale: string = "";
    public readonly segmento: string = "";
    public readonly dataDecorrenza: string = "";
    public readonly fonte: string = "";
    public readonly dettaglioFonte: string = "";
    public readonly agente: string = "";
    public readonly tipologiaPratica: string = "";
    public readonly dataRinnovoCq?: string = "";
    public readonly rataRinnovoCq?: string = undefined;
    public readonly mesiRinnovoCq?: string = "";
    public readonly sex?: string = "";
    public readonly idDipendenteSub?: number = undefined;
    public readonly segnalazione: string = "0";
    public readonly dipendenteBanca: boolean = false;

    public readonly guid: string = ""; // identificativo univoco associato a ogni richiesta di simulazione (utile per creditonet e cedibilita)

    constructor(data: Partial<SimulazioneStepOneFormModel>) {
        super();

        this.update(data);
    }
}
